import React from 'react';
import { translate } from 'Shared/translate';
import LoginContainer from 'Shared/Login/Container';
import Icon from 'Shared/Icon';
import * as styles from './sign-up-link.scss';
const ProductCardSignUpLink = () => (React.createElement(LoginContainer, null, ({ signUpUrl }) => (React.createElement("a", { href: signUpUrl, className: styles.base },
    React.createElement(Icon, { name: "account", className: styles.icon }),
    ' ',
    React.createElement("span", { className: styles.text }, translate('/Account/Registration/SignUp'))))));
export default ProductCardSignUpLink;
